export const styles = {
  select: (collapsed) => ({
    width: collapsed ? 60 : 80,
    height: 40,
    backgroundColor: "buttons.planned",
    borderColor: "buttons.main",
    borderRadius: "8px",
    border: "1px solid #d4d2cdff",
    fontWeight: 500,
    fontSize: "14px",
    transition: "all 0.3s ease",
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      justifyContent: collapsed ? "center" : "flex-start",
      padding: "8px 12px",
      paddingRight: collapsed ? "28px !important" : "36px !important",
      paddingLeft: collapsed ? "8px !important" : "16px !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {},
    "& .MuiSelect-icon": {
      color: "text.secondary",
      right: collapsed ? "6px" : "10px",
    },
  }),

  menuPaper: {
    backgroundColor: "primary.main",
    borderRadius: "8px",
    marginTop: "8px",
    border: "1px solid",
    borderColor: "primary.light",
    "& .MuiList-root": {
      padding: "8px",
    },
  },

  menuItem: {
    color: "primary.contrastText",
    borderRadius: "6px",
    marginBottom: "4px",
    fontSize: "14px",
    fontWeight: 500,
    padding: "10px 16px",
    "&:last-child": {
      marginBottom: 0,
    },
  },

  menuItemContent: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    width: "100%",
  },

  bulletFilled: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "secondary.main",
    lineHeight: 1,
  },

  bulletOutlined: {
    fontSize: "16px",
    fontWeight: "normal",
    color: "rgba(255, 206, 2, 0.4)",
    lineHeight: 1,
    WebkitTextStroke: "1px rgba(255, 206, 2, 0.6)",
    WebkitTextFillColor: "transparent",
  },
};

export const languageSwitcherWrapper = (dir) => ({
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  ...(dir === "rtl"
    ? { left: "24px", right: "auto" }
    : { right: "24px", left: "auto" }),
});
